// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__13JIg","topBottomGutter":"Layout_topBottomGutter__2y8Na"};